module.exports = __webpack_public_path__ + "static/media/upload-img.efebaadc.png";